import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from "./components/header/header.component";
import { FooterComponent } from "./components/footer/footer.component";
import { ApmService } from '@elastic/apm-rum-angular';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'enrollment-ui';

  constructor(private apmService: ApmService){
    const apm = apmService.init({
      serviceName: 'enrolment-ui',
      serverUrl: 'https://a0a8ef0e37c24c97b653cc656826be4b.apm.westus2.azure.elastic-cloud.com:443',
      environment: environment.Production ? 'prod' : 'test',
    });
  }
}
